import { Box, Stack } from '@mui/material';
// import { common } from '@mui/material/colors';
// import BaseInputNumber from 'common/components/base-input-number';
// import RequiredLabel from 'common/components/required-label';
import React from 'react';
import { IQuestionBaseProps } from 'types/campaign-design';
// import { createStyleSheet } from 'utils/helpers';
import QuestionDnD from './question-dnd';

const QuestionImage: React.FC<IQuestionBaseProps> = ({
    question,
    ...props
}) => {
    return (
        <Box>
            <Stack p={'0px 35px 35px 35px'} gap={1}>
                <Box sx={{ display: 'flex', alignItems: 'start', gap: 6 }}>
                    <QuestionDnD {...props} question={question} />
                    <Box sx={{ width: '100%' }}></Box>
                </Box>
            </Stack>
            {/* <Stack
                flexDirection={'row'}
                flexWrap={'wrap'}
                gap={4}
                p={'35px'}
                sx={{
                    borderTop: `2px dashed var(--color-primary)`,
                }}
            >
                <Stack flexDirection={'column'} gap={'20px'}>
                    <RequiredLabel
                        label="Giới hạn dung lượng upload (Mb)"
                        required={false}
                        sx={{ fontSize: '16px', fontWeight: '500' }}
                    />
                    <BaseInputNumber
                        sx={styles.limitSize}
                        size="small"
                        name={`data.limitSize`}
                    />
                </Stack>
            </Stack> */}
        </Box>
    );
};

// const styles = createStyleSheet({
//     limitSize: {
//         '& .MuiInputBase-root': {
//             height: '24px',
//             background: common.white,
//             maxWidth: '247px',
//             fieldset: {
//                 border: `1px solid ${common.black}`,
//             },
//         },
//     },
// });
export default QuestionImage;
